import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Select, DatePicker } from "antd";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import OrderPage, { OrderFilters, STATUS_TABS_CONFIG, MainTab, StatusTab } from "./OrderPage";
import { getOrderList } from "../../api/Order";

const { Option } = Select;

const { RangePicker } = DatePicker;

type TabKey = "ORDER_ID" | "PRODUCT" | "TIME";

const TAB_CONFIG: Record<TabKey, { label: string; width: number; left: number }> = {
    ORDER_ID: { label: "Mã đơn", width: 120, left: 0 },
    PRODUCT: { label: "Sản phẩm", width: 120, left: 120 },
    TIME: { label: "Ngày tháng", width: 140, left: 240 },
};

export default function MyOrderSearch() {
    const [activeTab, setActiveTab] = useState<TabKey>("ORDER_ID");
    const [filters, setFilters] = useState<OrderFilters>({});

    const [orderIdInput, setOrderIdInput] = useState("");
    const [selectedProduct, setSelectedProduct] = useState<string | undefined>(undefined);
    const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(dayjs("01/01/2026", "DD/MM/YYYY"));
    const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(dayjs("29/01/2026", "DD/MM/YYYY"));

    // State lifted from OrderPage
    const [mainTab, setMainTab] = useState<MainTab>("ALL");
    const [statusTab, setStatusTab] = useState<StatusTab>("ALL");
    const [page, setPage] = useState(1);
    const [orders, setOrders] = useState<any[]>([]);
    const [totalOrders, setTotalOrders] = useState(0);

    const handleSearch = () => {
        const newFilters: OrderFilters = {};
        if (activeTab === "ORDER_ID") {
            if (orderIdInput) newFilters.search = orderIdInput;
        } else if (activeTab === "PRODUCT") {
            if (selectedProduct) newFilters.productId = selectedProduct;
        } else if (activeTab === "TIME") {
            if (startDate) newFilters.startDate = startDate.format("YYYY-MM-DD");
            if (endDate) newFilters.endDate = endDate.format("YYYY-MM-DD");
        }
        setFilters(newFilters);
        setPage(1); // Reset page on search
    };

    // Use effect to fetch when page/status/filters changes
    useEffect(() => {
        const fetchOrders = async () => {
            const currentTab = STATUS_TABS_CONFIG.find(t => t.key === statusTab);
            const statusId = currentTab?.statusId;
            const res = await getOrderList(
                page, 
                10, 
                'created_at,desc', 
                statusId, 
                filters?.search, 
                filters?.startDate, 
                filters?.endDate, 
                filters?.productId
            );
            if (res && res.status) {
                setOrders(res.data.items);
                setTotalOrders(res.data.total);
            } else {
                setOrders([]);
                setTotalOrders(0);
            }
        };
        fetchOrders();
    }, [page, statusTab, filters]);

    // Reset Page on status change
    useEffect(() => {
        setPage(1);
    }, [statusTab]);

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__Kzodx mui-fixed MuiPaper-elevation4 w-full-1199-24px show-1199">
                <div className="MuiToolbar-root MuiToolbar-regular styles_toolBar__DQTee MuiToolbar-gutters">
                    <Link to="/" className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHamburger__POqzB" aria-label="back pagehome">
                        <span className="MuiButton-label">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/arrow-left.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </span>
                        <span className="MuiTouchRipple-root"></span>
                    </Link>
                    <p className="MuiTypography-root styles_formTitle__o8AZx MuiTypography-body1">Đơn hàng của tôi</p>
                </div>
            </header>
            <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item show-1199-pt-50px">
                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                    <div className="MuiGrid-root styles_wrapTopBox__XHXzW MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                        <div
                            className="MuiGrid-root styles_myOrder__q4l0d MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-6"
                            style={{ height: "31px" }}
                        >
                            <p className="MuiTypography-root MuiTypography-body1">
                                Đơn Hàng Của Tôi
                            </p>
                        </div>

                        <div
                            className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-6"
                            style={{ height: "31px" }}
                        >
                            <div className="styles_infoOrderRed__yz7vR MuiBox-root css-0">
                                <p className="MuiTypography-root MuiTypography-body1">
                                    {" "}
                                    Xem thông tin xuất hoá đơn đỏ &nbsp;
                                </p>
                                <Link to="/my-account?tab=invoice_info" className="MuiTypography-root MuiTypography-body1 styles_linkRed__qj8sP">
                                    tại đây
                                </Link>
                            </div>
                        </div>

                        <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-grid-xs-12">
                            <p className="MuiTypography-root styles_textSearch__wHy8F MuiTypography-body1">
                                Tìm Kiếm
                            </p>

                            <div className="MuiTabs-root styles_tabList__qKvzE">
                                <div
                                    className="MuiButtonBase-root MuiTabScrollButton-root MuiTabs-scrollButtons styles_hideBtn__4dQ97 Mui-disabled"
                                    aria-disabled="false"
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
                                    </svg>
                                    <span className="MuiTouchRipple-root"></span>
                                </div>

                                {/* ⚠️ GIỮ NGUYÊN FULL STYLE */}
                                <div
                                    className="MuiTabs-scrollable"
                                    style={{
                                        width: "99px",
                                        height: "99px",
                                        position: "absolute",
                                        top: "-9999px",
                                        overflow: "scroll",
                                    }}
                                ></div>

                                <div
                                    className="MuiTabs-scroller MuiTabs-scrollable"
                                    style={{ marginBottom: "0px" }}
                                >
                                    <div
                                        aria-label="orderList-tabs"
                                        className="MuiTabs-flexContainer"
                                        role="tablist"
                                    >
                                        {(Object.keys(TAB_CONFIG) as TabKey[]).map((key) => {
                                            const isActive = activeTab === key;

                                            return (
                                                <button
                                                    key={key}
                                                    className={`MuiButtonBase-root MuiTab-root MuiTab-textColorInherit styles_tabOrder__QRtMV
                                                    ${isActive ? "Mui-selected styles_sellected__E5Yq5" : ""}
                                                    `}
                                                    tabIndex={isActive ? 0 : -1}
                                                    type="button"
                                                    role="tab"
                                                    aria-selected={isActive}
                                                    onClick={() => setActiveTab(key)}
                                                >
                                                    <span className="MuiTab-wrapper">
                                                        {TAB_CONFIG[key].label}
                                                    </span>
                                                </button>
                                            );
                                        })}
                                    </div>

                                    <span
                                        className="jss11 jss13 MuiTabs-indicator styles_indicator__UMOsv"
                                        style={{
                                            left: `${TAB_CONFIG[activeTab].left}px`,
                                            width: `${TAB_CONFIG[activeTab].width}px`,
                                        }}
                                    ></span>
                                </div>

                                <div
                                    className="MuiButtonBase-root MuiTabScrollButton-root MuiTabs-scrollButtons styles_hideBtn__4dQ97 Mui-disabled"
                                    aria-disabled="false"
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                                    </svg>
                                    <span className="MuiTouchRipple-root"></span>
                                </div>
                            </div>

                            <div
                                className="MuiTabPanel-root"
                                role="tabpanel"
                                aria-labelledby="mui-p-34974-T-ORDER_ID"
                                id="mui-p-34974-P-ORDER_ID"
                            ></div>

                            <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                                {activeTab === "ORDER_ID" && (
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-lg-10">
                                            <div className="styles_wrapInput__q2s4B MuiBox-root css-0">
                                                <div className="MuiInputBase-root MuiInput-root styles_root_input__h2YV_ MuiInput-underline">
                                                    <input
                                                        placeholder="Nhập mã đơn"
                                                        type="search"
                                                        className="MuiInputBase-input MuiInput-input"
                                                        value={orderIdInput}
                                                        onChange={(e) => setOrderIdInput(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="MuiGrid-root styles_wrapBtnSearch__NN_8I MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-lg-1"
                                            style={{ marginLeft: "24px" }}
                                        >
                                            <button
                                                className="MuiButtonBase-root MuiButton-root MuiButton-text jss16 jss19 styles_BtnSearch__yNRZX"
                                                tabIndex={0}
                                                type="button"
                                                onClick={handleSearch}
                                            >
                                                <span className="MuiButton-label">Tìm Kiếm</span>
                                                <span className="MuiTouchRipple-root"></span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                                {activeTab === "PRODUCT" && (
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-lg-10">
                                            <div className="styles_wrapInput__q2s4B MuiBox-root css-0">
                                                <div className="MuiInputBase-root MuiInput-root styles_root_input__h2YV_ MuiInput-underline select-none-border">
                                                    <Select
                                                        showSearch
                                                        allowClear
                                                        placeholder="Sản phẩm"
                                                        className="product-select"
                                                        style={{ width: "100%" }}
                                                        optionFilterProp="label"
                                                        notFoundContent="Chưa nhập sản phẩm"
                                                        suffixIcon={<DownOutlined />}
                                                        value={selectedProduct}
                                                        onChange={(val) => setSelectedProduct(val)}
                                                        filterOption={(input, option) =>
                                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        options={[
                                                            { value: "sp1", label: "Paracetamol 500mg" },
                                                            { value: "sp2", label: "Vitamin C 1000mg" },
                                                            { value: "sp3", label: "Thuốc ho Prospan" },
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="MuiGrid-root styles_wrapBtnSearch__NN_8I MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-lg-1"
                                            style={{ marginLeft: "24px" }}
                                        >
                                            <button
                                                className="MuiButtonBase-root MuiButton-root MuiButton-text jss16 jss19 styles_BtnSearch__yNRZX"
                                                tabIndex={0}
                                                type="button"
                                                onClick={handleSearch}
                                            >
                                                <span className="MuiButton-label">Tìm Kiếm</span>
                                                <span className="MuiTouchRipple-root"></span>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {activeTab === "TIME" && (
                                    <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-7 MuiGrid-grid-lg-10">
                                            <div style={{ display: "flex", gap: 16, alignItems: "center" }} className="ctrl-h-40">
                                                <span>Từ</span>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    value={startDate}
                                                    onChange={(date) => setStartDate(date)}
                                                />

                                                <span>Đến</span>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    value={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                />
                                            </div>
                                        </div>

                                        <div
                                            className="MuiGrid-root styles_wrapBtnSearch__NN_8I MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-lg-1"
                                            style={{ marginLeft: "24px" }}
                                        >
                                            <button
                                                className="MuiButtonBase-root MuiButton-root MuiButton-text jss16 jss19 styles_BtnSearch__yNRZX"
                                                tabIndex={0}
                                                type="button"
                                                onClick={handleSearch}
                                            >
                                                <span className="MuiButton-label">Tìm Kiếm</span>
                                                <span className="MuiTouchRipple-root"></span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <OrderPage 
                        orders={orders}
                        totalOrders={totalOrders}
                        page={page}
                        setPage={setPage}
                        mainTab={mainTab}
                        setMainTab={setMainTab}
                        statusTab={statusTab}
                        setStatusTab={setStatusTab}
                    />
                </div>
            </div>
        </div>
    );
}
